import { Html } from '@react-three/drei';
import { RenderComponentStrategy } from './render-component.strategy';

export class SizeArrow extends RenderComponentStrategy<{ label: string }> {
	componentKey: string;

	public render() {
		const { position, rotation, color, scale, options } = this.options;

		return (
			<group scale={scale} position={position} rotation={rotation}>
				<mesh>
					<boxGeometry args={[0.01, 0.98, 0.01]} />
					<meshStandardMaterial color={color} />
				</mesh>
				<mesh position={[0, -0.49, 0]}>
					<boxGeometry args={[0.06, 0.01, 0.01]} />
					<meshStandardMaterial color={color} />
				</mesh>
				<mesh position={[0, 0.49, 0]}>
					<boxGeometry args={[0.06, 0.01, 0.01]} />
					<meshStandardMaterial color={color} />
				</mesh>
				<Html>
					<div
						style={{
							background: 'gray',
							padding: '4px 8px',
							borderRadius: '4px',
							fontSize: '14px',
							whiteSpace: 'nowrap',
							pointerEvents: 'none',
							color: 'white',
							transform: 'translate(-50%, -50%)',
						}}
					>
						{options.label}
					</div>
				</Html>
			</group>
		);
	}
}
